import { RawIPListType, UserPod } from '../types';

export type SetListIPsAction = {
  type: 'set_list_ips';
  ips: RawIPListType;
};

export type SetUserPodAction = {
  type: 'set_user_pod';
  pod: UserPod;
};

export type ListIpsAction = SetListIPsAction | SetUserPodAction;

export const LIST_IPS_ACTIONS = {
  SET_LIST_IPS: (ips: RawIPListType): SetListIPsAction => ({
    type: 'set_list_ips',
    ips,
  }),
  SET_USER_POD: (pod: UserPod): SetUserPodAction => ({
    type: 'set_user_pod',
    pod,
  }),
};
